webpackJsonp([264598414423048],{

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FadeAnim = __webpack_require__(10);
	
	var _FadeAnim2 = _interopRequireDefault(_FadeAnim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageDesc = function PageDesc(_ref) {
	  var title = _ref.title,
	      text = _ref.text;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'pageDesc innerPage is-bold' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-four-fifths' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              _FadeAnim2.default,
	              { direction: 'up' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'title' },
	                title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                text
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PageDesc.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired
	};
	
	exports.default = PageDesc;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = exports.AboutPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(12);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _fontawesomeSvgCore = __webpack_require__(32);
	
	var _reactFontawesome = __webpack_require__(47);
	
	var _freeSolidSvgIcons = __webpack_require__(46);
	
	var _FadeAnim = __webpack_require__(10);
	
	var _FadeAnim2 = _interopRequireDefault(_FadeAnim);
	
	var _HeroPage = __webpack_require__(33);
	
	var _HeroPage2 = _interopRequireDefault(_HeroPage);
	
	var _PageDesc = __webpack_require__(48);
	
	var _PageDesc2 = _interopRequireDefault(_PageDesc);
	
	var _Separator = __webpack_require__(49);
	
	var _Separator2 = _interopRequireDefault(_Separator);
	
	var _PageShapes = __webpack_require__(34);
	
	var _PageShapes2 = _interopRequireDefault(_PageShapes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faMapMarkerAlt);
	
	var BussinessStructure = function BussinessStructure(_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      _FadeAnim2.default,
	      { className: 'section', direction: 'up' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'brandTitle centerArt ' },
	        content.title
	      ),
	      _react2.default.createElement(
	        'p',
	        { style: { textAlign: 'center' } },
	        content.text
	      )
	    )
	  );
	};
	var Locations = function Locations(_ref2) {
	  var content = _ref2.content;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container locations' },
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        _FadeAnim2.default,
	        { direction: 'up' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'brandTitle centerArt ' },
	          content.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center' } },
	          content.text
	        )
	      ),
	      _react2.default.createElement(
	        _FadeAnim2.default,
	        { direction: 'up' },
	        _react2.default.createElement(
	          'div',
	          { style: { textAlign: 'center' }, className: 'columns is-centered' },
	          content.places.map(function (place) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'column', style: { marginTop: 20 }, key: place.label },
	              _react2.default.createElement(
	                'div',
	                { className: 'icon' },
	                _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: 'map-marker-alt' })
	              ),
	              _react2.default.createElement(
	                'h6',
	                null,
	                place.label
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	var Expansion = function Expansion(_ref3) {
	  var content = _ref3.content;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container expansion' },
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'brandTitle centerArt ' },
	        content.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'columns ' },
	        _react2.default.createElement(
	          _FadeAnim2.default,
	          { className: 'column is-half para leftp', direction: 'right' },
	          content.left_paragraph
	        ),
	        _react2.default.createElement(
	          _FadeAnim2.default,
	          { className: 'column is-half para rightp', direction: 'left' },
	          content.right_parahraph
	        )
	      )
	    )
	  );
	};
	var AboutPageTemplate = exports.AboutPageTemplate = function AboutPageTemplate(_ref4) {
	  var title = _ref4.title,
	      image = _ref4.image,
	      pageDescription = _ref4.pageDescription,
	      bussinessStructure = _ref4.bussinessStructure,
	      locations = _ref4.locations,
	      expansion = _ref4.expansion;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_PageShapes2.default, { top1: 600, top2: 1200, top3: 1400 }),
	    _react2.default.createElement(_HeroPage2.default, { title: title, imgSrc: image }),
	    _react2.default.createElement(_PageDesc2.default, { title: pageDescription.title, text: pageDescription.text }),
	    _react2.default.createElement(_Separator2.default, null),
	    _react2.default.createElement(BussinessStructure, { content: bussinessStructure }),
	    _react2.default.createElement(_Separator2.default, null),
	    _react2.default.createElement(Locations, { content: locations }),
	    _react2.default.createElement(_Separator2.default, null),
	    _react2.default.createElement(Expansion, { content: expansion })
	  );
	};
	
	AboutPageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	var AboutPage = function AboutPage(_ref5) {
	  var data = _ref5.data;
	  var post = data.markdownRemark;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        post.frontmatter.meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: post.frontmatter.meta_description })
	    ),
	    _react2.default.createElement(AboutPageTemplate, {
	      title: post.frontmatter.title,
	      image: post.frontmatter.hero_image,
	      pageDescription: post.frontmatter.page_description,
	      bussinessStructure: post.frontmatter.bussiness_structure,
	      locations: post.frontmatter.locations,
	      expansion: post.frontmatter.expansion
	    })
	  );
	};
	
	AboutPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = AboutPage;
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-page-js-dabbd97b112ff1544031.js